import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { CheckCircleIcon, TrashIcon } from '@heroicons/react/24/outline';

const HasDoneEventNode = ({ data, id, outputEdges, onEdgeCountChange }) => {
  // Define edge labels
  const edgeLabels = ['Yes', 'No'];

  // Define color schemes based on source
  const colors = {
    border: 'border-[#F6971A80]',
    rounded: 'rounded-lg',
    gradient: 'from-[#F6971A30] to-[#F6971A60]',
    borderBottom: 'border-[#F6971A80]',
    text: 'text-[#F6971A]',
    handle: 'border-2 border-[#F6971A] !bg-[#F6971A] hover:!bg-[#F6971A80]'
  };

  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`bg-white p-2 ${colors.rounded} shadow-lg border-2 ${colors.border} relative`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div 
        className={`absolute -top-3 left-1/2 -translate-x-1/2 w-5 h-5 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-600 hover:text-white z-10 transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <TrashIcon className='w-4 h-4 p-0.5 hover:text-white text-black'/>
      </div>

      <div className={`p-3 py-5 bg-gradient-to-r ${colors.gradient} border-b ${colors.borderBottom} ${colors.rounded}`}>
        <div className="flex items-center gap-2">
          <CheckCircleIcon className='w-8 h-8 p-1.5 bg-white text-[#F6971A] rounded-full'/>
          <span className={`font-semibold ${colors.text}`}>Has done event?</span>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Left}
        className={`w-4 h-4 ${colors.handle}`}
      />

      <div className="absolute right-0 top-1/2 -translate-y-1/2 h-[50px]">
        {Array.from({ length: outputEdges }).map((_, index) => (
          <div 
            key={`output-${index}`} 
            className="relative w-full"
            style={{
              top: `${(index * 100) / (outputEdges - 1)}%`,
              transform: 'translateY(-50%)'
            }}
          >
            <Handle
              type="source"
              position={Position.Right}
              id={`output-${index}`}
              className={`w-4 h-4 ${colors.handle}`}
            />
            <div 
              className={`absolute text-[10px] ${colors.text} transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0'} flex items-center gap-1`}
              style={{
                left: '5px',
                top: '-6px',
              }}
            >
              {edgeLabels[index]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HasDoneEventNode; 
